define('gumbo-js-client-lib/forms/liveData/PitchForm',['require','exports','module','jquery','./PitchMetaDataForm'],function(require, exports, module) {
	var $ = require("jquery"),
		pitchMetaDataFormat = require("./PitchMetaDataForm");
	return {
		count: {
			balls: null,
			strikes: null,
			colorCommentary: null
		},
		details: {
			call: null,
			description: null,
			ballColor: null,
			isInPlay: null,
			trailColor: null,
			displayName: null,
			type: null
		},
		stats: $.extend({}, pitchMetaDataFormat),
		id: null,
		index: null,
		isPitch: null,
		name: null,
		tfs: null,
		sportsvisionID: null
	}
});
